export const WEEK_DAYS = [
  ['monday', 'Segunda-feira'],
  ['tuesday', 'Terça-feira'],
  ['wednesday', 'Quarta-feira'],
  ['thursday', 'Quinta-feira'],
  ['friday', 'Sexta-feira'],
];

export const PEDAGOGICAL_AXES = [
  'Língua Portuguesa',
  'Matemática',
  'Ciências da Natureza',
  'Ciências da Sociedade',
  'Cultura Corporal',
  'Artes Visuais',
  'Música',
  'Artes Literária',
];

export const EVALUATION_STATUS_OPTIONS = [
  ['D', 'Desenvolvido'],
  ['ED', 'Em desenvolvimento'],
  ['ND', 'Não desenvolvido'],
  ['NA', 'Não se aplica'],
];

const item = (key, label, options = {}) => ({ key, label, ...options });

export const PEDAGOGICAL_EVALUATION_SECTIONS = [
  {
    key: 'portuguese',
    title: 'Língua Portuguesa',
    groups: [
      {
        title: 'Oralidade',
        items: [
          item('verbalExpression', 'Se expressa por meio de linguagem verbal', { choices: ['Balbucia', 'Palavras', 'Frases', 'Mantém diálogo'] }),
          item('alternativeCommunication', 'Faz uso de Comunicação Alternativa e Suplementar'),
          item('pointsToExpress', 'Aponta o que deseja para se expressar'),
          item('simpleCommands', 'Responde comandos simples'),
          item('listensStories', 'Demonstra interesse para ouvir histórias'),
          item('retellsFacts', 'Reconta fatos simples (histórias, ocorrências do dia a dia)'),
          item('collectiveText', 'Contribui na construção de texto coletivo'),
          item('transmitsMessages', 'Transmite recados'),
        ],
      },
      {
        title: 'Leitura',
        items: [
          item('alphabet', 'Alfabeto', { choices: ['Conhece', 'Identifica', 'Reconhece'] }),
          item('ownName', 'Quanto ao nome', { choices: ['Conhece', 'Identifica', 'Reconhece'] }),
          item('wordsAndSigns', 'Associa palavras e signos'),
          item('imageReading', 'Realiza leitura de imagem (rótulos, marcas, placas e outros)'),
        ],
      },
      {
        title: 'Pré-história da escrita',
        items: [
          item('letterTracing', 'Apresenta o traçado das letras'),
          item('writesOwnName', 'Escreve o próprio nome'),
        ],
      },
    ],
  },
  {
    key: 'mathematics',
    title: 'Matemática',
    groups: [
      {
        title: 'Espaço e forma',
        items: [
          item('geometricShapes', 'Formas geométricas', { choices: ['Conhece', 'Identifica', 'Diferencia'] }),
          item('spatialNotions', 'Apresenta noções de espaço (perto/longe)'),
          item('colors', 'Cores', { choices: ['Conhece', 'Identifica', 'Diferencia'] }),
          item('logicalSequence', 'Apresenta noções de sequência lógica'),
          item('classification', 'Apresenta noções de classificação'),
          item('seriation', 'Apresenta noções de seriação'),
        ],
      },
      {
        title: 'Grandezas e medidas',
        items: [
          item('size', 'Apresenta noções de tamanho (grande/pequeno)'),
          item('height', 'Apresenta noções de altura (alto/baixo)'),
          item('time', 'Apresenta noções de tempo (ontem/hoje/amanhã)'),
          item('thickness', 'Apresenta noções de espessura (grosso/fino)'),
        ],
      },
      {
        title: 'Números',
        items: [
          item('counting', 'Realiza contagem até o numeral', { extraLabel: 'Até o numeral' }),
          item('numbers', 'Números', { choices: ['Conhece', 'Identifica', 'Diferencia'] }),
          item('numberQuantity', 'Associa numeral e quantidade', { extraLabel: 'Até' }),
          item('numberWriting', 'Realiza escrita de números', { extraLabel: 'Até' }),
        ],
      },
      {
        title: 'Operações',
        items: [
          item('joinQuantities', 'Compreende o processo de juntar quantidades'),
          item('separateQuantities', 'Compreende o processo de separar quantidades'),
        ],
      },
      {
        title: 'Tratamento da informação',
        items: [
          item('simpleProblems', 'Resolve problemas matemáticos simples'),
          item('tablesCharts', 'Interpreta tabelas e gráficos concretos'),
          item('calendar', 'Utiliza calendário de forma funcional'),
        ],
      },
    ],
  },
  {
    key: 'nature',
    title: 'Ciências da Natureza',
    groups: [
      {
        title: 'Seres vivos',
        items: [
          item('bodyParts', 'Partes do corpo', { choices: ['Conhece', 'Identifica', 'Diferencia'] }),
          item('livingNonLiving', 'Identifica seres vivos e não vivos'),
        ],
      },
      {
        title: 'Elementos do meio ambiente e fenômenos naturais',
        items: [
          item('dayNight', 'Apresenta noção de dia e noite'),
          item('fruits', 'Frutas', { choices: ['Conhece', 'Identifica', 'Diferencia'] }),
          item('animals', 'Animais', { choices: ['Conhece', 'Identifica', 'Diferencia'] }),
          item('natureElements', 'Identifica elementos da natureza como árvore, rio, flores e outros'),
        ],
      },
      {
        title: 'Ser humano e qualidade de vida',
        items: [
          item('personalHygiene', 'Manifesta comportamentos de higiene pessoal'),
          item('bathroom', 'Uso de banheiro', { choices: ['Conhece', 'Identifica', 'Diferencia'] }),
          item('feeding', 'Alimentação', { choices: ['Conhece', 'Identifica', 'Diferencia'] }),
          item('locomotionResource', 'Locomoção - utiliza algum recurso?', { choices: ['Sim', 'Não'], extraLabel: 'Qual recurso' }),
        ],
      },
    ],
  },
  {
    key: 'society',
    title: 'Ciências da Sociedade',
    groups: [
      {
        title: 'Relação indivíduo e sociedade',
        items: [
          item('integratedSchool', 'Está integrado ao ambiente escolar'),
          item('independentSchoolMobility', 'Locomove-se pela escola com independência'),
          item('acceptsGroupPlay', 'Aceita brincar em grupo'),
          item('dangerAwareness', 'Apresenta noção de perigo'),
          item('routineSupport', 'Necessita de apoio durante as atividades rotineiras'),
          item('identifiesTeacher', 'Identifica a sua professora'),
          item('transport', 'Meios de transporte', { choices: ['Conhece', 'Identifica', 'Diferencia'] }),
          item('housing', 'Meios de habitação', { choices: ['Conhece', 'Identifica', 'Diferencia'] }),
          item('communication', 'Meios de comunicação', { choices: ['Conhece', 'Identifica', 'Diferencia'] }),
          item('identifiesFriends', 'Identifica os amigos da turma'),
        ],
      },
      {
        title: 'Trabalho e relações de produção',
        items: [
          item('remainsClass', 'Consegue permanecer em sala de aula durante as atividades'),
          item('sitsForActivities', 'Senta para realização de atividades'),
          item('finishesActivity', 'Realiza uma atividade até o final'),
          item('interestedActivity', 'Interessa-se pela atividade em execução'),
        ],
      },
      {
        title: 'Tempo histórico e tempo geográfico',
        items: [
          item('understandsRoutine', 'Compreende o tempo e a rotina em função das atividades'),
        ],
      },
      {
        title: 'Práticas culturais',
        items: [
          item('gamesGroup', 'Aceita participar de jogos e brincadeiras em grupo'),
          item('celebrations', 'Aceita participar de festas e comemorações na escola'),
          item('outings', 'Participa de passeios e atividades extracurriculares'),
        ],
      },
    ],
  },
  {
    key: 'art',
    title: 'Arte',
    groups: [
      {
        title: 'Artes Visuais',
        items: [
          item('holdsPencil', 'Segura o lápis'),
          item('paints', 'Consegue pintar'),
          item('paintsWithinBoundary', 'Desenha ou pinta no limite do espaço delimitado'),
          item('tearing', 'Realiza rasgadura'),
          item('scissors', 'Sabe manusear tesoura'),
          item('modelingClay', 'Manipula massinha'),
          item('glue', 'Sabe manusear cola'),
          item('drawing', 'Desenho', { choices: ['Garatuja desordenada', 'Garatuja ordenada', 'Simbolização', 'Intenção', 'Figura humana completa', 'Figura humana incompleta'] }),
        ],
      },
      {
        title: 'Música',
        items: [
          item('singsGroup', 'Canta em grupo'),
          item('musicalTimbres', 'Diferencia timbres musicais'),
          item('noiseIrritation', 'Demonstra irritação com sons e ruídos'),
          item('schoolSongs', 'Conhece canções do cotidiano escolar'),
          item('musicInterest', 'Demonstra interesse por músicas'),
        ],
      },
      {
        title: 'Arte Literária',
        items: [
          item('theaterInterest', 'Apresenta interesse por peças teatrais'),
          item('appreciatesArt', 'Sabe apreciar sua produção artística e a dos amigos'),
        ],
      },
    ],
  },
  {
    key: 'bodyCulture',
    title: 'Cultura Corporal',
    groups: [
      {
        title: 'Brincadeiras de situações opositivas',
        items: [
          item('groupPlay', 'Aceita ou consegue participar de brincadeiras em grupo'),
          item('activityToEnd', 'Realiza uma atividade até o fim'),
          item('broadCoordination', 'Apresenta coordenação motora ampla'),
          item('specificCoordination', 'Apresenta coordenação motora específica'),
        ],
      },
      {
        title: 'Brincadeiras de destreza e desafios corporais',
        items: [
          item('imitatesMovements', 'Consegue imitar movimentos'),
          item('stairsAlternating', 'Sobe escadas alternando os pés'),
          item('playgroundToys', 'Utiliza os brinquedos do parque'),
        ],
      },
      {
        title: 'Brincadeiras de imitação/criação de formas artísticas',
        items: [
          item('animalSounds', 'Participa de brincadeiras de imitação com sons de animais e ruídos do cotidiano'),
          item('rolePlay', 'Brinca de faz de conta e jogos de papéis'),
        ],
      },
    ],
  },
];

const emptyActivityBlock = () => ({
  space: '',
  knowledgeArea: '',
  axis: '',
  development: '',
});

const emptyMainActivity = () => ({
  theme: '',
  space: '',
  knowledgeArea: '',
  axis: '',
  goals: '',
  objectives: '',
  contents: '',
  development: '',
  resources: '',
});

export const createEmptyPlanningDay = () => ({
  date: '',
  arrivalTime: '07:30 - 08:00',
  breakfastTime: '08:00 - 08:30',
  call: emptyActivityBlock(),
  conversationMusic: emptyActivityBlock(),
  calendar: emptyActivityBlock(),
  helperOfDay: emptyActivityBlock(),
  mainActivity: emptyMainActivity(),
  secondaryActivity: { time: '10:00 - 10:20', ...emptyMainActivity() },
  hygieneTime: '10:35 - 10:50',
  lunchTime: '10:40 - 10:50',
  waterBathroomTime: '11:20',
  sleepTime: '11:30',
  observationEvaluation: '',
});

export const createPlanningData = (responsibleName = '') => ({
  month: '',
  year: String(new Date().getFullYear()),
  weekStart: '',
  weekEnd: '',
  teacherName: responsibleName || '',
  pedagogicalSummary: '',
  axes: Object.fromEntries(PEDAGOGICAL_AXES.map((axis) => [axis, false])),
  weekly: Object.fromEntries(WEEK_DAYS.map(([key]) => [key, { proposal: '' }])),
  days: Object.fromEntries(WEEK_DAYS.map(([key]) => [key, createEmptyPlanningDay()])),
});

export const createReferralData = (responsibleName = '') => ({
  date: new Date().toISOString().slice(0, 10),
  teacherName: responsibleName || '',
  eligibility: {
    hearing: false,
    visual: false,
    physical: false,
    intellectual: false,
    multiple: false,
    autism: false,
    giftedness: false,
    specialNeeds: false,
  },
  otherEligibility: '',
  studentHistory: '',
  referralReason: '',
  measuresTaken: '',
  signatures: {
    guardian: '',
    director: '',
    teacher: responsibleName || '',
  },
});

export const createEvaluationData = (responsibleName = '') => ({
  date: new Date().toISOString().slice(0, 10),
  referralDate: '',
  teacherName: responsibleName || '',
  sections: Object.fromEntries(PEDAGOGICAL_EVALUATION_SECTIONS.map((section) => [
    section.key,
    {
      observations: '',
      items: Object.fromEntries(section.groups.flatMap((group) => group.items).map((entry) => [
        entry.key,
        { status: '', help: '', choices: [], extra: '' },
      ])),
    },
  ])),
  signatures: {
    director: '',
    teacher: responsibleName || '',
  },
});
